import React from 'react';
import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

import { PropertySelectField } from '@paragon/client-tools';
import { MiscellaneousItem, Trailer, TruckDriver } from '@paragon/contract-library';

import { getTrailerOptions } from '../../../selectors/trailers';
import { getTruckDriverOptions } from '../../../selectors/truckDrivers';
import { useAppSelector } from '../../hooks';
import { MiscellaneousItemsTable } from './MiscellaneousItemsTable';

interface TruckloadPropertiesProps {
  readonly trailer: Trailer | null;
  readonly setTrailer: (trailer: Trailer | null) => void;
  readonly truckDriver: TruckDriver | null;
  readonly setTruckDriver: (truckDriver: TruckDriver | null) => void;
  readonly shipDate: Date | null;
  readonly setShipDate: (date: Date | null) => void;
  readonly miscellaneousItems: readonly MiscellaneousItem[];
  readonly setMiscellaneousItems: (miscellaneousItems: readonly MiscellaneousItem[]) => void;
  readonly setParentSubmitDisabled: (parentSubmitDisabled: boolean) => void;
}

export function TruckloadProperties(props: TruckloadPropertiesProps) {
  const {
    trailer,
    setTrailer,
    truckDriver,
    setTruckDriver,
    shipDate,
    setShipDate,
    miscellaneousItems,
    setMiscellaneousItems,
    setParentSubmitDisabled,
  } = props;
  const trailerOptions = useAppSelector(getTrailerOptions);
  const truckDriverOptions = useAppSelector(getTruckDriverOptions);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <PropertySelectField<Trailer>
          property="Trailer"
          value={trailer}
          options={trailerOptions}
          getName={(trailer) => trailer.name}
          getValue={(trailer) => trailer.guid}
          submit={(trailer) => {
            setTrailer(trailer);
          }}
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <PropertySelectField<TruckDriver>
          property="Truck Driver"
          value={truckDriver}
          options={truckDriverOptions}
          getName={(truckDriver) => truckDriver.name}
          getValue={(truckDriver) => truckDriver.guid}
          submit={(truckDriver) => {
            setTruckDriver(truckDriver);
          }}
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={shipDate ? dayjs(shipDate) : null}
            label="Ship Date"
            onChange={(date) => {
              setShipDate(date?.toDate() ?? null);
            }}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ mb: 2 }}>
        <MiscellaneousItemsTable
          miscellaneousItems={miscellaneousItems}
          setMiscellaneousItems={setMiscellaneousItems}
          setParentSubmitDisabled={setParentSubmitDisabled}
        />
      </Box>
    </>
  );
}
